<template>
  <div id="app">
    <!-- START NAV -->
    <nav class="navbar">
      <div class="container has-text-centered">
        <div class="navbar-item center">
          <a href="/">
            <img
              src="@/assets/img/logo4.png"
              alt="logo Na co ci to? Strony z pomysłami na prezenty i gażdetami"
            />
          </a>
        </div>
      </div>
    </nav>
    <nav class="navbar">
      <div class="container has-text-centered">
        <a class="navbar-item is-tab center" href="/">Strona Główna</a>
        <router-link
          tag="a"
          class="navbar-item is-tab center"
          :to="{name: 'aboutus'}"
        >O nas, wsparcie i kontakt</router-link>
      </div>
    </nav>
    <!-- END NAV -->

    <div class="container">
      <div class="section">
        <div class="box">
          <div class="field has-addons">
            <div class="control is-expanded">
              <input
                class="input has-text-centered"
                type="search"
                placeholder="» » » » » » znajdź mnie « « « « « «"
                v-model="searchQuery"
                @keyup.enter="goToSearchResults"
              />
            </div>
            <div class="control">
              <a
                class="button"
                @click="goToSearchResults"
                :disabled="searchQuery == ''"
                :class="{'is-danger': searchQuery != ''}"
              >Szukaj</a>
            </div>
          </div>
        </div>
        <router-view></router-view>
      </div>
    </div>
    <cookie-law buttonText="Akceptuję">
      <div slot="message">
        Informujemy, iż w celu udostępnienia funkcjonalności dostępnych na naszej stronie, optymalizacji jej treści oraz dostosowania strony do Państwa indywidualnych potrzeb korzystamy z informacji zapisanych za pomocą plików cookies na urządzeniach końcowych użytkowników. Pliki cookies można kontrolować za pomocą ustawień swojej przeglądarki internetowej. Dalsze korzystanie z naszej strony internetowej, bez zmiany ustawień przeglądarki internetowej oznacza, iż użytkownik akceptuje stosowanie plików cookies. Więcej informacji zawartych jest w
        <a
          href="/static/Polityka_Prywatnosci_nacocito.pdf"
        >polityce prywatności strony</a>.
      </div>
    </cookie-law>
    <footer class="footer">
      <div class="container">
        <div class="content has-text-centered">
          <div class="soc">
            <a href="https://www.facebook.com/Na-co-ci-to-102130438062224">
              <i class="fab fa-facebook fa-2x" aria-hidden="true"></i>
            </a>
            <a v-show="false" href="#">
              <i class="fab fa-twitter fa-2x" aria-hidden="true"></i>
            </a>
          </div>
          <p>
            <strong>Na co ci to?</strong>
          </p>
        </div>
        <div class="columns">
          <div class="column is-2"></div>
          <div class="column">
            <div class="columns">
              <div class="column">
                <h3 class="has-text-weight-bold">nacocito.pl</h3>
                <li>
                  <a
                    class="has-text-white"
                    type="application/json"
                    target="_blank"
                    ref="noreferrer noopener"
                    href="/static/Regulamin_nacocito.pdf"
                  >Regulamin</a>
                </li>
                <li>
                  <a
                    class="has-text-white"
                    type="application/json"
                    target="_blank"
                    ref="noreferrer noopener"
                    href="/static/Polityka_Prywatnosci_nacocito.pdf"
                  >Polityka prywatności</a>
                </li>
              </div>
              <div class="column">
                <h3 class="has-text-weight-bold">Współpraca</h3>
                <li>
                  <a
                    class="has-text-white"
                    href="mailto:nacocito@wonsystudio.com?subject=Współpraca"
                  >Napisz do nas</a>
                </li>
                <li>
                  <a
                    href="https://zbierajmonety.pl"
                    class="has-text-white"
                    rel="noreferrer noopener"
                    target="_blank"
                  >Inwestowanie w monety bulionowe</a>
                </li>
                <li>
                  <a
                    href="https://jakibroker.pl"
                    class="has-text-white"
                    rel="noreferrer noopener"
                    target="_blank"
                  >Jakiego brokera wybrać?</a>
                </li>
                <li>
                  <a
                    href="https://all4words.com"
                    class="has-text-white"
                    rel="noreferrer noopener"
                    target="_blank"
                  >Zdalne biuro tłumaczeń all4words</a>
                </li>
                <li>
                  <a
                    href="https://gseo.pl"
                    class="has-text-white"
                    rel="noreferrer noopener"
                    target="_blank"
                  >Agencja Marketingu Cyfrowego GSEO</a>
                </li>
              </div>
              <div class="column">
                <h3 class="has-text-weight-bold">Zobacz także</h3>
                <li>
                  <a href="https://nacocito.pl" class="has-text-white">strój borata</a>
                </li>
                <li>
                  <a
                    href="https://nacocito.pl"
                    class="has-text-white"
                  >najlepsze prezenty na urodziny</a>
                </li>
                <li>
                  <a href="https://nacocito.pl" class="has-text-white">prezent dla dziewczyny</a>
                </li>
                <li>
                  <a href="https://nacocito.pl" class="has-text-white">prezent dla chłopaka</a>
                </li>
                <li>
                  <a href="https://nacocito.pl" class="has-text-white">śmieszne gadżety</a>
                </li>
              </div>
            </div>
          </div>
          <div class="column is-2"></div>
        </div>
      </div>
    </footer>
  </div>
</template>

<script>
import CookieLaw from "vue-cookie-law";

export default {
  name: "app",
  components: { CookieLaw },

  data() {
    return { searchQuery: "" };
  },
  methods: {
    goToSearchResults() {
      this.$router.push({
        name: "searchresults",
        query: { q: this.searchQuery },
      });
    },
  },
};
</script>

<style>
.navbar-item.center {
  flex-grow: 1;
  flex-direction: column;
  justify-content: center;
}
</style>
